import { OWN_ACCOMMODATION_ROOM_TYPE } from './itinerary';

export const isServiceOnDepartureDay = (dayOfService = 1, nights = 1) => (dayOfService > nights ? { OnDepartureDay: true } : {});

export const isDmcArranged = segment => segment.arrangedBy === 'DMC';
export const isOwnArranged = segment => segment.arrangedBy === 'Agent' || segment.roomType === OWN_ACCOMMODATION_ROOM_TYPE;
